import { queryOptions } from '@tanstack/vue-query'
import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack'

export const useGetProductFiltersQuery = (
  productGroupKey: Ref<string>,
  otherOptions?: Ref<NitroFetchOptions<NitroFetchRequest>>
) => {
  const { $productsFiltersRepository } = useNuxtApp()
  const { slugUrl } = useBaseRoutes()
  const { queryFilterType } = useQueryHelper()
  // To set locale and country for preview mode in order to get the correct data from CS
  const { previewHeaders } = usePreviewLayoutMeta()

  const options = computed(() => {
    return {
      query: {
        [`filter[${queryFilterType.value}]`]:
          queryFilterType.value === 'product_group'
            ? productGroupKey?.value
            : slugUrl.value,
        include: 'brands,categories,filter_types.filter_values',
      },
      headers: {
        ...previewHeaders.value,
      },
      ...toValue(otherOptions),
    }
  })

  return queryOptions({
    queryKey: ['products-filters', options],
    queryFn: () => $productsFiltersRepository.index(unref(options)),
  })
}
